import { render, staticRenderFns } from "./RequestKanbanBoardBlock.vue?vue&type=template&id=de94aa10&scoped=true"
import script from "@/components/request/RequestKanbanBoardBlock/RequestKanbanBoardBlock.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestKanbanBoardBlock/RequestKanbanBoardBlock.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestKanbanBoardBlock/request-kanban-board-block.scss?vue&type=style&index=0&id=de94aa10&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de94aa10",
  null
  
)

export default component.exports